<template>
  <v-main class="core-view-auth">
    <div>
      <router-view :key="$route.path" />
    </div>
  </v-main>
</template>

<script>
export default {
 
}
</script>

<style lang="scss">
.core-view-auth {
  background-image: url("/img/template.png");
  background-repeat: no-repeat;
  background-size: cover;
  h2, h3 {
    color: #526d87;
  }
}
</style>
